import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"
import { JuniferService } from "@/services/JuniferService"

export const getJuniferTickets = (accountNumber: string) => {
  const queries = new QueryAggregator()
  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  const ticketsQuery = JuniferService.getTicketsForAccount(coreIdQuery.data)

  queries.add(coreIdQuery)
  queries.add(ticketsQuery)

  return queries.setData(ticketsQuery.data).getAggregate()
}
